import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import styles from "./text-block.module.css"
export default function TextBlock({ block }) {
  if (block.innerBlocks.length === 0) {
    return null
  }

  return (
    <Block block={block} className={styles.wrapper}>
      <Blocks blocks={block.innerBlocks} />
    </Block>
  )
}
